/**
 * TODO: Factorize with CAPEX Intelligence ? Almost the same 😕
 */

import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import * as R from 'ramda';

import { KPI } from './api';
import {
  DataType, FilterType, PerimeterFilter, PerimeterFilterRangeValue, PerimeterFilterValue, PerimeterPredicate,
} from './perimeter-filter';

/**
 * Defines a perimeter filter displayed in the `PerimetersFiltersDialogComponent`.
 */
export class ParentPerimeterTypeFilter extends PerimeterFilter {
  constructor(
    label: string,
    perimeterTypes: KPI.PerimeterType[]
  ) {
    super();

    this.id = 'parent-perimeter-type';
    this.label = label;
    this.filtering = FilterType.FILTER_VALUE;
    this.dataType = DataType.DATA_TYPE_FK;
    this.availableValues = perimeterTypes
      .filter((perimeterType) => perimeterType.level === 1)
      .map((cluster) => {
        return {
          id: cluster.id,
          label: cluster.name,
        };
      });
  }

  public getPredicate(values: PerimeterFilterValue[] | PerimeterFilterRangeValue): PerimeterPredicate {
    return (perimeter: KPI.Perimeter) => {
      const filterValues = <PerimeterFilterValue[]>values;
      const levelParentPerimeterType = perimeter.levelParentPerimeterType;
      // Is level parent and is in the filter values
      return (!perimeter.level_parent && R.includes(perimeter.perimeter_type, filterValues.map(Number)))
        // Is level child and has a level parent in the filter values
        || (levelParentPerimeterType && R.includes(levelParentPerimeterType, filterValues.map(Number)))
        // Is site and has a level parent in the filter values
        || perimeter.sub_perimeters
          ?.filter((subPerimeter) => !subPerimeter.level_parent)
          .some((subPerimeter) => R.includes(subPerimeter.perimeter_type, filterValues.map(Number)));
    };
  }
}
